import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class BOQDashboardService extends BaseService {

  protected http: HttpClient;

  constructor(http: HttpClient, tokenService: TokenService) {
    super(tokenService);
    this.http = http;
  }

  // Get Services
  getVendorApplicationForMIBOQ(userId: String) {
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorApplicationForMIBOQ?UserId=` + userId, { headers: this.buildHeaders() });
  }

  getVendorMIBOQ(reqBody){
    return this.http.get<any>(`${environment.apiUrl}DashBoard/GetVendorMIBOQ?AppId=${reqBody.AppId}&VendorRegId=${reqBody.VendorRegId}&ProgId=${reqBody.ProgramId}`);
  }

  //post
  insertVendorBOQ(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}DashBoard/InsertVendorBOQ`, reqBody);
  }
}